// Storefront — French. Keys are the English source text.
export default {
  // Header, footer, navigation
  "Vehicle-checked parts": "Pièces vérifiées pour votre véhicule",
  "from verified sellers": "auprès de vendeurs vérifiés",
  "Compare listings · Seller trust badges": "Comparez les annonces · Badges de confiance vendeur",
  "Can't find it? Sellers reply to part requests": "Introuvable ? Les vendeurs répondent aux demandes de pièces",
  "Track order": "Suivre ma commande",
  "PartHub home": "Accueil PartHub",
  "OEM · aftermarket · used": "Origine · adaptable · occasion",
  "Search parts": "Rechercher des pièces",
  "Part name, SKU or OEM number…": "Nom de la pièce, SKU ou référence OEM…",
  "Search": "Rechercher",
  "Your vehicle": "Votre véhicule",
  "No vehicle": "Aucun véhicule",
  "Select vehicle": "Choisir un véhicule",
  "Signed in": "Connecté",
  "Hello, sign in": "Bonjour, connectez-vous",
  "Account": "Compte",
  "Open cart, 1 item": "Ouvrir le panier, 1 article",
  "Open cart, {n} items": "Ouvrir le panier, {n} articles",
  "Cart": "Panier",
  "Categories": "Catégories",
  "Quick navigation": "Navigation rapide",
  "Language": "Langue",
  "All Categories": "Toutes les catégories",
  "Brakes & Suspension": "Freinage & suspension",
  "Engine & Filters": "Moteur & filtres",
  "Electrical & Lighting": "Électricité & éclairage",
  "Transmission": "Transmission",
  "Exhaust": "Échappement",
  "Fluids & Oils": "Liquides & huiles",
  "Request a part": "Demander une pièce",
  "Home": "Accueil",
  "Parts": "Pièces",
  "Garage": "Garage",
  "Request": "Demande",
  "The trusted marketplace for OEM and aftermarket auto parts. Search by vehicle, compare listings, and buy from sellers with clearer trust signals.":
    "La place de marché de confiance pour les pièces auto d'origine et adaptables. Recherchez par véhicule, comparez les annonces et achetez auprès de vendeurs fiables.",
  "Shop": "Boutique",
  "Browse All Parts": "Toutes les pièces",
  "Shop by Vehicle": "Acheter par véhicule",
  "OEM Parts": "Pièces d'origine",
  "Compare Parts": "Comparer des pièces",
  "Sign In / Register": "Connexion / Inscription",
  "My Orders": "Mes commandes",
  "My Garage": "Mon garage",
  "Saved Compare": "Comparaisons enregistrées",
  "My Account": "Mon compte",
  "Support": "Assistance",
  "Track My Order": "Suivre ma commande",
  "Order Confirmation": "Confirmation de commande",
  "Seller Center": "Espace vendeur",
  "Contact Support": "Contacter l'assistance",
  "Help Center": "Centre d'aide",
  "© 2026 PartHub Inc. All rights reserved.": "© 2026 PartHub Inc. Tous droits réservés.",

  // Cart drawer & cart page
  "1 item": "1 article",
  "{n} items": "{n} articles",
  "Your cart": "Votre panier",
  "Close cart": "Fermer le panier",
  "Your cart is empty": "Votre panier est vide",
  "Your cart is empty.": "Votre panier est vide.",
  "Browse parts for your {vehicle}.": "Parcourez les pièces pour votre {vehicle}.",
  "Select your vehicle first so you only see parts that fit.": "Choisissez d'abord votre véhicule pour ne voir que les pièces compatibles.",
  "Browse parts": "Voir les pièces",
  "Shopping for": "Achats pour",
  ". Check the fitment on each part's page, or confirm the OEM number with the seller.":
    ". Vérifiez la compatibilité sur la fiche de chaque pièce, ou confirmez la référence OEM avec le vendeur.",
  "No vehicle selected, so fitment hasn't been checked.": "Aucun véhicule choisi : la compatibilité n'a pas été vérifiée.",
  "Select your vehicle": "Choisir votre véhicule",
  "Sold by {seller}": "Vendu par {seller}",
  "Quantity for {title}": "Quantité pour {title}",
  "Decrease quantity": "Diminuer la quantité",
  "Increase quantity": "Augmenter la quantité",
  "{price} each": "{price} l'unité",
  "Remove": "Retirer",
  "Subtotal": "Sous-total",
  "Shipping": "Livraison",
  "Calculated at checkout": "Calculée à la commande",
  "Checkout ·": "Commander ·",
  "View full cart": "Voir le panier complet",
  "Review selected parts before checkout.": "Vérifiez les pièces choisies avant de commander.",
  "Browse the marketplace and add parts to continue.": "Parcourez le catalogue et ajoutez des pièces pour continuer.",
  "Review selected parts and continue to checkout.": "Vérifiez les pièces choisies et passez à la commande.",
  "Checkout context includes your selected vehicle:": "La commande inclura votre véhicule :",
  "No vehicle selected. You can still checkout, but fitment confirmation is stronger when a vehicle is selected.":
    "Aucun véhicule choisi. Vous pouvez commander, mais la compatibilité est mieux vérifiée avec un véhicule.",
  "Seller: {seller}": "Vendeur : {seller}",
  "Estimated total": "Total estimé",
  "Continue to checkout": "Passer la commande",
  "Clear cart": "Vider le panier",
  "Sign in at checkout to track your order. Final fitment confirmation should still rely on SKU, OEM reference, and seller guidance.":
    "Connectez-vous à la commande pour suivre votre colis. La compatibilité finale se confirme avec le SKU, la référence OEM et le vendeur.",

  // Checkout
  "Full name is required.": "Le nom complet est obligatoire.",
  "Phone number is required.": "Le numéro de téléphone est obligatoire.",
  "Address line 1 is required.": "L'adresse est obligatoire.",
  "City is required.": "La ville est obligatoire.",
  "Order placed successfully.": "Commande passée avec succès.",
  "Failed to place order": "Impossible de passer la commande",
  "Add parts to your cart before proceeding to checkout.": "Ajoutez des pièces à votre panier avant de commander.",
  "Sign in to check out": "Connectez-vous pour commander",
  "Your cart is saved. Sign in or create a free account so you can track the order and the seller can reach you.":
    "Votre panier est conservé. Connectez-vous ou créez un compte gratuit pour suivre la commande et être joignable par le vendeur.",
  "Sign in to continue": "Connectez-vous pour continuer",
  "Checkout": "Commande",
  "Confirm your delivery details. Sellers may call to confirm fitment before shipping.":
    "Confirmez vos informations de livraison. Le vendeur peut appeler pour confirmer la compatibilité avant l'envoi.",
  "Your selected vehicle will be attached as checkout context:": "Votre véhicule sera joint à la commande :",
  "No vehicle selected. You can still place the order, but fitment confidence is stronger when a vehicle is selected.":
    "Aucun véhicule choisi. Vous pouvez commander, mais la compatibilité est plus sûre avec un véhicule.",
  "Delivery details": "Informations de livraison",
  "Where should the seller deliver your parts?": "Où le vendeur doit-il livrer vos pièces ?",
  "Full name": "Nom complet",
  "Email (optional)": "E-mail (facultatif)",
  "Phone": "Téléphone",
  "Address line 1": "Adresse",
  "Street address": "Rue et numéro",
  "Address line 2 (optional)": "Complément d'adresse (facultatif)",
  "Apartment, suite, etc.": "Appartement, étage, etc.",
  "City": "Ville",
  "State / Region": "Région",
  "Postal code": "Code postal",
  "Country": "Pays",
  "Order notes (optional)": "Notes de commande (facultatif)",
  "Add delivery notes or fitment confirmation requests...": "Ajoutez des consignes de livraison ou une demande de vérification…",
  "Placing order...": "Commande en cours…",
  "Place order": "Commander",
  "Order summary": "Récapitulatif",
  "Items": "Articles",
  "Delivery (flat rate)": "Livraison (forfait)",
  "Total": "Total",
  "Final fitment confirmation should still rely on SKU, OEM reference, and seller confirmation where needed.":
    "La compatibilité finale se confirme avec le SKU, la référence OEM et, si besoin, le vendeur.",
  "Checkout trust": "Commande en confiance",
  "• Your order appears in your account with a tracking reference.": "• Votre commande apparaît dans votre compte avec une référence de suivi.",
  "• Vehicle context is attached when selected.": "• Le véhicule choisi est joint à la commande.",
  "• Seller follow-up can still confirm final fitment before fulfillment.": "• Le vendeur peut confirmer la compatibilité avant l'expédition.",
  "• SKU and notes remain important for high-confidence orders.": "• Le SKU et vos notes restent importants pour une commande sûre.",
  "Verified": "Vérifié",

  // Checkout success
  "Hello, I just placed an order on PartHub.": "Bonjour, je viens de passer une commande sur PartHub.",
  "Order ID: {id}": "N° de commande : {id}",
  "Vehicle: {vehicle}": "Véhicule : {vehicle}",
  "I would like to confirm the next steps and fitment context.": "Je souhaite confirmer les prochaines étapes et la compatibilité.",
  "Order received": "Commande reçue",
  "Your order has been placed": "Votre commande est passée",
  "Thank you. Your request is now recorded and the seller can review the order details.":
    "Merci. Votre commande est enregistrée et le vendeur peut maintenant l'examiner.",
  "What happens next": "Et ensuite ?",
  "1. Seller reviews the order": "1. Le vendeur examine la commande",
  "The seller checks availability, fitment context, and order details.": "Le vendeur vérifie la disponibilité, la compatibilité et les détails.",
  "2. Fitment may be reconfirmed": "2. La compatibilité peut être reconfirmée",
  "SKU, OEM reference, and seller notes may still be used to confirm final compatibility.":
    "Le SKU, la référence OEM et les notes du vendeur servent à confirmer la compatibilité.",
  "3. Delivery and payment follow-up": "3. Livraison et paiement",
  "Shipping timing and final fulfillment steps are handled after seller confirmation.":
    "Le délai de livraison et l'expédition sont réglés après confirmation du vendeur.",
  "Continue browsing": "Continuer mes achats",
  "Confirm on WhatsApp": "Confirmer sur WhatsApp",
  "Order reference": "Référence de commande",
  "Generated successfully": "Générée avec succès",
  "Checkout type": "Type de commande",
  "Guest checkout": "Commande invité",
  "Vehicle context": "Véhicule",
  "Not attached": "Non joint",
  "Keep your SKU references and fitment notes nearby in case the seller asks for confirmation.":
    "Gardez vos références SKU et notes de compatibilité à portée de main si le vendeur demande une confirmation.",
  "Buyer advice": "Conseils acheteur",
  "• Save your vehicle in the garage for faster future searches.": "• Enregistrez votre véhicule dans le garage pour chercher plus vite.",
  "• Use WhatsApp if you need confirmation before shipping.": "• Utilisez WhatsApp si vous voulez une confirmation avant l'envoi.",
  "• Keep part SKU and vehicle year ready for follow-up.": "• Gardez le SKU de la pièce et l'année du véhicule pour le suivi.",

  // Home
  "Engine": "Moteur",
  "Brakes": "Freinage",
  "Electrical": "Électricité",
  "Filters": "Filtres",
  "Suspension": "Suspension",
  "Lighting": "Éclairage",
  "Flash Deals": "Bonnes affaires",
  "✓ 2.4M+ Parts · 1,200+ Verified Sellers": "✓ 2,4 M+ pièces · 1 200+ vendeurs vérifiés",
  "Find the Right Part,": "Trouvez la bonne pièce,",
  "Every Time": "à chaque fois",
  "Search by vehicle, part name, OEM number, or VIN. Use Garage context and trust signals to reach the right listing faster.":
    "Cherchez par véhicule, nom de pièce, référence OEM ou numéro VIN. Votre garage et les badges de confiance vous mènent plus vite à la bonne annonce.",
  "By Vehicle": "Par véhicule",
  "By Part Name": "Par nom de pièce",
  "OEM / Part #": "Réf. OEM / pièce",
  "By VIN": "Par VIN",
  "Year": "Année",
  "Select Year": "Choisir l'année",
  "Make": "Marque",
  "Select Make": "Choisir la marque",
  "Model": "Modèle",
  "Select Model": "Choisir le modèle",
  "Open Garage": "Ouvrir le garage",
  "Search Compatible Parts": "Chercher les pièces compatibles",
  "Change Vehicle": "Changer de véhicule",
  "e.g. front brake pads, oil filter, alternator…": "ex. plaquettes avant, filtre à huile, alternateur…",
  "Search Parts": "Rechercher",
  "e.g. 90915-YZZD2, 04152-YZZA4…": "ex. 90915-YZZD2, 04152-YZZA4…",
  "Look Up Part Number": "Rechercher la référence",
  "17-character VIN": "VIN à 17 caractères",
  "Find Parts by VIN": "Trouver par VIN",
  "Popular:": "Populaire :",
  "Brake Pads": "Plaquettes de frein",
  "Oil Filter": "Filtre à huile",
  "Spark Plugs": "Bougies",
  "Alternator": "Alternateur",
  "Shock Absorbers": "Amortisseurs",
  "Parts in catalog": "Pièces au catalogue",
  "Verified sellers": "Vendeurs vérifiés",
  "Average buyer rating": "Note moyenne des acheteurs",
  "Browse categories": "Parcourir les catégories",
  "Start from a common parts family": "Commencez par une famille de pièces",
  "See all": "Tout voir",
  "Featured discovery": "À découvrir",
  "High-intent starting points for buyers": "Les recherches les plus demandées",
  "View all": "Tout voir",
  "Front Brake Pads Kit": "Kit de plaquettes avant",
  "Vehicle compatibility added": "Compatibilité véhicule renseignée",
  "Sale": "Promo",
  "Performance Air Filter": "Filtre à air performance",
  "Popular vehicle match": "Compatible véhicules populaires",
  "New": "Nouveau",
  "Spark Plug Set": "Jeu de bougies",
  "Garage-friendly search": "Recherche par garage",
  "Rear Shock Absorber Pair": "Paire d'amortisseurs arrière",
  "Compatibility-first listing": "Annonce avec compatibilité",
  "Top verified sellers": "Meilleurs vendeurs vérifiés",
  "Seller trust and storefront discovery": "Vendeurs de confiance et leurs boutiques",
  "Why PartHub": "Pourquoi PartHub",
  "The cleaner buyer journey": "Un achat plus simple",
  "Fitment-first discovery, verified sellers, tracked orders, and support-oriented flows.":
    "Recherche par compatibilité, vendeurs vérifiés, commandes suivies et assistance.",
  "Vehicle Compatibility Check": "Vérification de compatibilité",
  "Filter discovery by your exact year, make, model, and engine context.": "Filtrez selon l'année, la marque, le modèle et la motorisation.",
  "Verified Sellers": "Vendeurs vérifiés",
  "Seller trust signals and public storefront access improve buyer confidence.": "Badges de confiance et boutiques publiques pour acheter sereinement.",
  "Fast Shipping Flow": "Commande rapide",
  "Cart, checkout, order history, and tracking pages already exist in the storefront.": "Panier, commande, historique et suivi, tout au même endroit.",
  "Compare Before You Buy": "Comparez avant d'acheter",
  "Compare shortlisted parts before opening details or moving to checkout.": "Comparez vos pièces favorites avant de commander.",

  // Parts for your vehicle
  "Your garage": "Votre garage",
  "Parts for your {vehicle}": "Pièces pour votre {vehicle}",
  "Listings with compatibility data for this vehicle.": "Annonces avec données de compatibilité pour ce véhicule.",
  "See all {n}": "Voir les {n}",
  "No parts are listed for your {vehicle} yet.": "Aucune pièce n'est encore listée pour votre {vehicle}.",
  "Send a request and sellers who stock {make} parts can reply with offers.":
    "Envoyez une demande : les vendeurs de pièces {make} pourront vous faire des offres.",
  "Browse all parts": "Voir toutes les pièces",
  "Fits your {vehicle}": "Compatible avec votre {vehicle}",
  "Fits your vehicle": "Compatible avec votre véhicule",
  "Unbranded": "Sans marque",

  // Parts list
  "Try a broader keyword than \"{q}\".": "Essayez un mot-clé plus large que « {q} ».",
  "Try searching by part name, SKU, or brand.": "Cherchez par nom de pièce, SKU ou marque.",
  "Your current vehicle filter is {vehicle}.": "Votre filtre véhicule actuel : {vehicle}.",
  "Clear the vehicle context to see a wider catalog.": "Retirez le véhicule pour voir tout le catalogue.",
  "Try removing the category filter.": "Essayez de retirer le filtre catégorie.",
  "Try removing the brand filter.": "Essayez de retirer le filtre marque.",
  "Try switching condition or removing it.": "Changez ou retirez le filtre d'état.",
  "Exact fit": "Compatible",
  "Vehicle match": "Véhicule correspondant",
  "Strong compatibility": "Bonne compatibilité",
  "Compatibility added": "Compatibilité renseignée",
  "Featured": "En vedette",
  "Low stock": "Stock faible",
  "Fitment-ready seller": "Vendeur avec compatibilités",
  "Well stocked": "Bien approvisionné",
  "Trusted seller": "Vendeur de confiance",
  "Used": "Occasion",
  "Aftermarket": "Adaptable",
  "Failed to load parts": "Impossible de charger les pièces",
  "Search: {q}": "Recherche : {q}",
  "Filtered marketplace search": "Recherche filtrée",
  "Loading parts...": "Chargement des pièces…",
  "1 result found": "1 résultat",
  "{n} results found": "{n} résultats",
  "{n} results": "{n} résultats",
  "Search by title, SKU, keyword...": "Titre, SKU, mot-clé…",
  "All categories": "Toutes les catégories",
  "All brands": "Toutes les marques",
  "All conditions": "Tous les états",
  "Refurbished": "Reconditionné",
  "Min price": "Prix min.",
  "Max price": "Prix max.",
  "Sort": "Trier",
  "Relevance": "Pertinence",
  "Newest": "Plus récents",
  "Price: Low to high": "Prix croissant",
  "Price: High to low": "Prix décroissant",
  "Clear filters": "Effacer les filtres",
  "Clear vehicle": "Retirer le véhicule",
  "Vehicle-aware parts search": "Recherche selon votre véhicule",
  "Find the right part faster": "Trouvez la bonne pièce plus vite",
  "Search listings by keyword, brand, category, and your selected vehicle context.":
    "Cherchez par mot-clé, marque, catégorie et selon votre véhicule.",
  "Selected vehicle:": "Véhicule choisi :",
  "Clear": "Effacer",
  "No vehicle selected. Search still works, but ranking is stronger with a vehicle selected.":
    "Aucun véhicule choisi. La recherche fonctionne, mais le classement est meilleur avec un véhicule.",
  "Save search": "Enregistrer",
  "Reset search": "Réinitialiser",
  "Refine results for faster matching.": "Affinez les résultats.",
  "Loading filters...": "Chargement des filtres…",
  "Showing broader marketplace results": "Résultats de tout le catalogue",
  "1 exact match for {vehicle}": "1 pièce compatible avec {vehicle}",
  "{n} exact matches for {vehicle}": "{n} pièces compatibles avec {vehicle}",
  "Only parts that fit my {vehicle}": "Uniquement les pièces pour ma {vehicle}",
  "Save this search": "Enregistrer cette recherche",
  "Vehicle-aware": "Selon le véhicule",
  "Exact matches": "Compatibles",
  "Broader fitment candidates": "Autres candidats",
  "Select your vehicle to unlock exact fitment ranking and stronger part matching.":
    "Choisissez votre véhicule pour classer les pièces par compatibilité.",
  "Top result": "Meilleur résultat",
  "Brand unavailable": "Marque inconnue",
  "View best match": "Voir la meilleure pièce",
  "Remove from shortlist": "Retirer des favoris",
  "Add to shortlist": "Ajouter aux favoris",
  "No exact matches found for your selected vehicle": "Aucune pièce compatible trouvée pour votre véhicule",
  "No parts found": "Aucune pièce trouvée",
  "No listings matched your current vehicle and filter combination.": "Aucune annonce ne correspond à votre véhicule et à vos filtres.",
  "No listings matched your current search and filter combination.": "Aucune annonce ne correspond à votre recherche et à vos filtres.",
  "Show all parts, best fit first": "Voir toutes les pièces, les plus compatibles d'abord",
  "Reset search filters": "Réinitialiser les filtres",
  "Can't find it? Request this part": "Introuvable ? Demandez cette pièce",
  "Clear vehicle filter": "Retirer le filtre véhicule",
  "SKU": "SKU",
  "Seller": "Vendeur",
  "Low stock · {n} left": "Stock faible · {n} restant(s)",
  "In stock · {n}": "En stock · {n}",
  "Same model, check the year": "Même modèle, vérifiez l'année",
  "Fits 1 vehicle setup": "Compatible avec 1 configuration",
  "Fits {n} vehicle setups": "Compatible avec {n} configurations",
  "No fitment data yet": "Pas encore de compatibilité",
  "Shortlisted": "En favoris",
  "Shortlist": "Favoris",
  "Add more": "Ajouter encore",
  "Add to Cart": "Ajouter au panier",
  "Sold out": "Épuisé",
  "Previous": "Précédent",
  "Next": "Suivant",
  "1 saved part": "1 pièce enregistrée",
  "{n} saved parts": "{n} pièces enregistrées",
  "Compare": "Comparer",
  "View": "Voir",
  "Refine marketplace results": "Affiner les résultats",
  "Close": "Fermer",

  // Part details
  "Part image": "Photo de la pièce",
  "Brand": "Marque",
  "Category": "Catégorie",
  "Condition": "État",
  "Location": "Localisation",
  "Weight": "Poids",
  "Select your vehicle to confirm fitment": "Choisissez votre véhicule pour vérifier la compatibilité",
  "Choose make, model, and year to verify whether this part matches your vehicle.":
    "Indiquez la marque, le modèle et l'année pour vérifier que cette pièce convient.",
  "This part has a compatibility row that matches your selected vehicle.": "Cette pièce est déclarée compatible avec votre véhicule.",
  "Compatibility not confirmed for your vehicle": "Compatibilité non confirmée pour votre véhicule",
  "This part includes compatibility data, but your selected vehicle is not an exact confirmed match.":
    "Cette pièce a des données de compatibilité, mais votre véhicule n'y figure pas exactement.",
  "No structured compatibility data yet": "Pas encore de données de compatibilité",
  "Use SKU, seller notes, and product details until compatibility data is expanded.":
    "Fiez-vous au SKU, aux notes du vendeur et à la description en attendant.",
  "No vehicle selected": "Aucun véhicule choisi",
  "Hello, I want to confirm this part.": "Bonjour, je souhaite confirmer cette pièce.",
  "Part: {title}": "Pièce : {title}",
  "Unknown part": "Pièce inconnue",
  "Failed to load part details": "Impossible de charger la pièce",
  "Loading part details...": "Chargement de la pièce…",
  "Part not found": "Pièce introuvable",
  "No image available": "Pas de photo",
  "Stock status": "Stock",
  "{n} available": "{n} disponible(s)",
  "Out of stock": "Rupture de stock",
  "Compatibility": "Compatibilité",
  "Vehicle-matched": "Compatible véhicule",
  "No description available for this part yet.": "Pas encore de description pour cette pièce.",
  "In stock ({n})": "En stock ({n})",
  "Unknown seller": "Vendeur inconnu",
  "1 compatibility row": "1 compatibilité",
  "{n} compatibility rows": "{n} compatibilités",
  "Exact match confirmed": "Compatibilité confirmée",
  "Save vehicle": "Enregistrer le véhicule",
  "Final purchase confidence should still confirm SKU, OEM reference, and seller guidance.":
    "Avant d'acheter, confirmez le SKU, la référence OEM et l'avis du vendeur.",
  "Adding...": "Ajout…",
  "Added to cart": "Ajouté au panier",
  "Add to cart": "Ajouter au panier",
  "Ask seller on WhatsApp": "Demander au vendeur sur WhatsApp",
  "Why buyers trust this listing": "Pourquoi cette annonce inspire confiance",
  "• SKU and structured compatibility improve confidence before purchase.": "• Le SKU et la compatibilité renseignée rassurent avant l'achat.",
  "• Stock visibility helps reduce surprise checkout failures.": "• Le stock affiché évite les mauvaises surprises.",
  "• Seller contact via WhatsApp makes pre-purchase confirmation easier.": "• Le contact WhatsApp facilite la confirmation avant achat.",
  "• Vehicle-aware matching helps rank the most relevant parts higher.": "• Le classement par véhicule met en avant les pièces pertinentes.",
  "Seller trust": "Confiance vendeur",
  "Seller:": "Vendeur :",
  "Unknown": "Inconnu",
  "Location:": "Localisation :",
  "Not specified": "Non précisé",
  "Listing status:": "Statut de l'annonce :",
  "Availability:": "Disponibilité :",
  "{n} unit(s) available": "{n} unité(s) disponible(s)",
  "Currently unavailable": "Indisponible pour le moment",
  "SKU:": "SKU :",
  "Strong parts usually include stock, SKU, compatibility, and easy seller confirmation paths.":
    "Une bonne annonce indique le stock, le SKU, la compatibilité et un contact vendeur simple.",
  "Quick fitment summary": "Résumé de compatibilité",
  "Selected vehicle": "Véhicule choisi",
  "Not selected": "Non choisi",
  "Compatibility rows": "Compatibilités",
  "Match status": "Statut",
  "Confirmed match": "Compatible",
  "Not confirmed": "Non confirmé",
  "Review all known vehicle matches for this part.": "Tous les véhicules compatibles connus pour cette pièce.",
  "No compatibility rows are available yet for this part.": "Aucune compatibilité renseignée pour cette pièce.",
  "Your selected vehicle matches": "Votre véhicule correspond",
  "Specifications": "Caractéristiques",
  "No technical specifications available yet.": "Pas encore de caractéristiques techniques.",
  "Purchase reassurance": "Acheter sereinement",
  "• Confirm exact fitment when your vehicle has engine or trim variations.": "• Confirmez la compatibilité si votre véhicule a plusieurs motorisations ou finitions.",
  "• Use seller contact before checkout if you need additional confidence.": "• Contactez le vendeur avant de commander en cas de doute.",
  "• SKU and compatibility rows are stronger trust signals than title alone.": "• Le SKU et la compatibilité valent mieux que le titre seul.",
  "• In-stock parts with structured fitment usually move faster and convert better.": "• Les pièces en stock avec compatibilité partent plus vite.",
  "Need another option?": "Besoin d'une autre option ?",
  "Explore related parts from the marketplace inventory.": "Découvrez des pièces similaires.",
  "No related parts available yet.": "Pas encore de pièces similaires.",
  "No image": "Pas de photo",
  "Match": "Compatible",
  "Added": "Ajouté",

  // Auth
  "Please enter your email and password.": "Saisissez votre e-mail et votre mot de passe.",
  "Please enter your full name.": "Saisissez votre nom complet.",
  "Account created successfully. Please sign in.": "Compte créé. Vous pouvez vous connecter.",
  "Authentication failed.": "Échec de la connexion.",
  "Buyer account": "Compte acheteur",
  "You are already signed in": "Vous êtes déjà connecté",
  "Continue to your account, orders, checkout, or return to the catalog.": "Accédez à votre compte, vos commandes, ou revenez au catalogue.",
  "Signed-in session": "Session active",
  "Email": "E-mail",
  "Cart items": "Articles au panier",
  "Continue": "Continuer",
  "Go to account": "Mon compte",
  "Buyer auth foundation": "Espace acheteur",
  "Create your buyer account": "Créez votre compte acheteur",
  "Access your buyer session for account, orders, cart, and checkout flow.": "Accédez à votre compte, vos commandes, votre panier et la commande.",
  "Create a buyer account to prepare a smoother storefront and checkout experience.": "Créez un compte acheteur pour commander plus facilement.",
  "✔ Buyer-only storefront auth": "✔ Compte réservé aux acheteurs",
  "✔ Session-ready checkout flow": "✔ Commande plus rapide",
  "Why sign in?": "Pourquoi se connecter ?",
  "Continue more smoothly from cart to checkout.": "Passez du panier à la commande sans friction.",
  "Prepare access to buyer account and order history foundation.": "Retrouvez votre compte et l'historique de vos commandes.",
  "Keep the storefront flow cleaner across future sessions.": "Retrouvez vos informations à chaque visite.",
  "Current storefront state": "État actuel",
  "Post-login redirect": "Après connexion",
  "Back to cart": "Retour au panier",
  "Sign in": "Se connecter",
  "Create account": "Créer un compte",
  "Buyer sign in": "Connexion acheteur",
  "Buyer registration": "Inscription acheteur",
  "Enter your email and password to continue.": "Saisissez votre e-mail et votre mot de passe.",
  "Create your buyer account with basic details.": "Créez votre compte avec quelques informations.",
  "Password": "Mot de passe",
  "Please wait...": "Veuillez patienter…",
  "Create buyer account": "Créer mon compte",
  "Don’t have an account?": "Pas encore de compte ?",
  "Create one": "Créer un compte",
  "Already have an account?": "Déjà un compte ?",

  // Garage, vehicle bar, saved searches, 404
  "Select and save a vehicle to unlock faster fitment-aware shopping.": "Choisissez et enregistrez un véhicule pour trouver plus vite les pièces compatibles.",
  "No active vehicle selected": "Aucun véhicule actif",
  "My garage": "Mon garage",
  "Save vehicles and switch fitment context instantly.": "Enregistrez vos véhicules et passez de l'un à l'autre.",
  "Save current": "Enregistrer l'actuel",
  "Active vehicle": "Véhicule actif",
  "Save to garage": "Enregistrer au garage",
  "No active vehicle selected yet.": "Aucun véhicule actif pour l'instant.",
  "No saved vehicles yet.": "Aucun véhicule enregistré.",
  "Currently active": "Actif",
  "Saved in garage": "Enregistré au garage",
  "Use vehicle": "Utiliser",
  "Saved searches": "Recherches enregistrées",
  "Save important searches and return to them quickly.": "Enregistrez vos recherches pour y revenir rapidement.",
  "No saved searches yet.": "Aucune recherche enregistrée.",
  "Re-open saved buyer intent in one click.": "Relancez une recherche en un clic.",
  "Saved search": "Recherche enregistrée",
  "No keyword": "Sans mot-clé",
  "Open": "Ouvrir",
  "Open in page": "Ouvrir dans la page",
  "Page Not Found": "Page introuvable",
  "The page you're looking for doesn't exist.": "La page que vous cherchez n'existe pas.",
  "Back to Home": "Retour à l'accueil",

  // Category names from the catalog (falls back to the stored name).
  "Body": "Carrosserie",
  "Cooling": "Refroidissement",
  "Interior": "Intérieur",
  "Steering": "Direction",
  "Wheels & Tyres": "Roues & pneus",
  "Batteries": "Batteries",
  "Accessories": "Accessoires",
  "Clutch": "Embrayage",

  // Phase 2: account, orders, tracking, compare, seller, vehicle selector, part requests
  "Basic listing": "Annonce simple",
  "Compare parts": "Comparer des pièces",
  "Compare shortlisted parts side by side.": "Comparez vos pièces favorites côte à côte.",
  "No parts selected for comparison": "Aucune pièce à comparer",
  "Add parts to shortlist from the search results first.": "Ajoutez d'abord des pièces aux favoris depuis la recherche.",
  "Review price, stock, fitment depth, and seller quality side by side.": "Comparez prix, stock, compatibilité et vendeur côte à côte.",
  "Clear compare": "Vider la comparaison",
  "Field": "Critère",
  "Open part": "Voir la pièce",
  "Price": "Prix",
  "Stock": "Stock",
  "{n} row(s)": "{n} compatibilité(s)",
  "Fitment signal": "Indice de compatibilité",
  "High relevance": "Très pertinent",
  "Standard": "Standard",
  "Hello, I accepted your offer on PartHub for \"{part}\" ({ref}).": "Bonjour, j'ai accepté votre offre sur PartHub pour « {part} » ({ref}).",
  "Dismantler": "Casse auto",
  "Best price": "Meilleur prix",
  "{n} months warranty": "Garantie {n} mois",
  "No warranty": "Sans garantie",
  "Available today": "Disponible aujourd'hui",
  "Ready in {n} days": "Prête sous {n} jours",
  "You accepted this offer. Contact the seller to arrange the sale:": "Vous avez accepté cette offre. Contactez le vendeur pour finaliser :",
  "WhatsApp seller": "WhatsApp du vendeur",
  "Accepting…": "Acceptation…",
  "Accept this offer": "Accepter cette offre",
  "Could not load this request": "Impossible de charger cette demande",
  "Accept the offer from {seller} for {price}? Other offers will be declined.": "Accepter l'offre de {seller} à {price} ? Les autres offres seront refusées.",
  "Could not accept this offer": "Impossible d'accepter cette offre",
  "Close this request? Sellers won't be able to send more offers.": "Fermer cette demande ? Les vendeurs ne pourront plus envoyer d'offres.",
  "Could not close this request": "Impossible de fermer cette demande",
  "Request not found": "Demande introuvable",
  "← Back to my requests": "← Retour à mes demandes",
  "← My requests": "← Mes demandes",
  "Request sent!": "Demande envoyée !",
  "Matching sellers can see it now. Come back here to compare their offers.": "Les vendeurs concernés la voient déjà. Revenez ici pour comparer leurs offres.",
  "OEM number": "Référence OEM",
  "Open until {date}": "Ouverte jusqu'au {date}",
  "Close request": "Fermer la demande",
  "Waiting for offers": "En attente d'offres",
  "Sellers who stock parts for your {make} can see your request in their inbox.": "Les vendeurs de pièces {make} voient votre demande dans leur boîte de réception.",
  "Offer accepted": "Offre acceptée",
  "Closed": "Fermée",
  "Expired": "Expirée",
  "Open for offers": "Ouverte",
  "New or used": "Neuve ou occasion",
  "Active seller": "Vendeur actif",
  "In stock": "En stock",
  "Breaker": "Casse auto",
  "Importer": "Importateur",
  "Parts Shop": "Magasin de pièces",
  "OEM Genuine": "Origine constructeur",
  "Used Part": "Pièce d'occasion",
  "Failed to load seller profile": "Impossible de charger le profil vendeur",
  "Loading seller profile...": "Chargement du profil vendeur…",
  "Seller not found": "Vendeur introuvable",
  "Seller profile": "Profil vendeur",
  "Browse this seller’s active inventory and trust signals before purchase.": "Consultez le stock et les badges de confiance de ce vendeur avant d'acheter.",
  "1 active part": "1 pièce active",
  "{n} active parts": "{n} pièces actives",
  "About this seller": "À propos du vendeur",
  "Seller type:": "Type de vendeur :",
  "Phone:": "Téléphone :",
  "Active listings:": "Annonces actives :",
  "Fitment-ready listings:": "Annonces avec compatibilité :",
  "Seller description": "Description du vendeur",
  "No seller description available yet.": "Pas encore de description.",
  "Why this seller may be trusted": "Pourquoi faire confiance à ce vendeur",
  "• Active inventory indicates this seller is currently participating in the marketplace.": "• Un stock actif montre que ce vendeur est présent sur la plateforme.",
  "• Fitment-ready listings usually reduce buyer hesitation and improve part matching.": "• Les annonces avec compatibilité facilitent le bon choix.",
  "• Stock visibility and structured compatibility are stronger trust signals than title alone.": "• Le stock affiché et la compatibilité valent mieux que le titre seul.",
  "Seller inventory": "Stock du vendeur",
  "Active marketplace listings from this seller.": "Annonces actives de ce vendeur.",
  "No active parts found for this seller.": "Aucune pièce active pour ce vendeur.",
  "{n} in stock": "{n} en stock",
  "View part": "Voir la pièce",
  "Could not load your requests": "Impossible de charger vos demandes",
  "Sign in to see your part requests": "Connectez-vous pour voir vos demandes",
  "My part requests": "Mes demandes de pièces",
  "Offers from sellers appear here as they come in.": "Les offres des vendeurs apparaissent ici dès leur arrivée.",
  "+ New request": "+ Nouvelle demande",
  "No requests yet": "Aucune demande",
  "Looking for a part that isn't listed? Describe it once and sellers will reply with offers.": "Une pièce introuvable ? Décrivez-la une fois et les vendeurs vous feront des offres.",
  "from {price}": "dès {price}",
  "Orders foundation": "Commandes",
  "Sign in to view your orders": "Connectez-vous pour voir vos commandes",
  "Buyer sign-in prepares access to order history and tracking entry points.": "La connexion donne accès à l'historique et au suivi de vos commandes.",
  "Recommended": "Recommandé",
  "Continue to your orders area.": "Accédez à vos commandes.",
  "Go to checkout": "Passer la commande",
  "Complete buyer details first.": "Complétez d'abord vos informations.",
  "Review cart": "Voir le panier",
  "You currently have {n} item(s).": "Vous avez {n} article(s).",
  "Your orders": "Vos commandes",
  "This storefront area is ready for buyer order history, status, and tracking integration.": "Retrouvez ici l'historique, le statut et le suivi de vos commandes.",
  "Back to account": "Retour au compte",
  "Buyer orders area": "Mes commandes",
  "Signed in as {email}.": "Connecté en tant que {email}.",
  "buyer": "acheteur",
  "No orders yet": "Aucune commande",
  "Once the real checkout submission flow is wired, completed orders can appear here.": "Vos commandes passées apparaîtront ici.",
  "Order flow status": "État des commandes",
  "Buyer authentication foundation: ready.": "Compte acheteur : prêt.",
  "Cart and checkout foundations: ready.": "Panier et commande : prêts.",
  "Real order history API integration: next backend-connected step.": "Historique des commandes : bientôt.",
  "Quick actions": "Actions rapides",
  "Failed to load vehicle makes": "Impossible de charger les marques",
  "Failed to load vehicle models": "Impossible de charger les modèles",
  "Failed to load vehicle years": "Impossible de charger les années",
  "Please choose make, model, and year.": "Choisissez la marque, le modèle et l'année.",
  "Vehicle Selector PRO MAX": "Choix du véhicule",
  "Choose your vehicle first": "Choisissez d'abord votre véhicule",
  "Select make, model, and year to browse parts faster and improve fitment accuracy.": "Choisissez la marque, le modèle et l'année pour trouver plus vite les pièces compatibles.",
  "✔ 30 makes": "✔ 30 marques",
  "✔ 150 models": "✔ 150 modèles",
  "✔ 3300 year entries": "✔ 3300 années",
  "Vehicle saved successfully.": "Véhicule enregistré.",
  "Start with the make, then model, then year.": "Commencez par la marque, puis le modèle, puis l'année.",
  "Loading makes...": "Chargement des marques…",
  "Select make": "Choisir la marque",
  "Choose make first": "Choisissez d'abord la marque",
  "Loading models...": "Chargement des modèles…",
  "Select model": "Choisir le modèle",
  "Choose model first": "Choisissez d'abord le modèle",
  "Loading years...": "Chargement des années…",
  "Select year": "Choisir l'année",
  "Current selection": "Sélection actuelle",
  "Why this matters": "Pourquoi c'est utile",
  "✔ Faster catalog browsing": "✔ Recherche plus rapide",
  "✔ Better fitment workflows": "✔ Compatibilité mieux vérifiée",
  "✔ Stronger vehicle-specific search foundation": "✔ Résultats adaptés à votre véhicule",
  "✔ Ready for VIN / plate lookup later": "✔ Recherche par VIN / immatriculation bientôt",
  "Your order has been captured in the storefront order flow.": "Votre commande a bien été enregistrée.",
  "Review in progress": "Vérification en cours",
  "Order details, buyer information, and part availability are being reviewed.": "Les détails, vos informations et la disponibilité sont vérifiés.",
  "Preparing dispatch": "Préparation de l'envoi",
  "The order is being prepared for shipment or seller confirmation.": "La commande est en préparation ou en attente du vendeur.",
  "Shipped": "Expédiée",
  "Tracking and delivery progress will appear here once shipment is live.": "Le suivi apparaîtra ici après l'expédition.",
  "Delivered": "Livrée",
  "Final delivery confirmation will appear at the end of the order flow.": "La confirmation de livraison apparaîtra à la fin.",
  "Tracking foundation": "Suivi",
  "Sign in to access order tracking": "Connectez-vous pour suivre votre commande",
  "Buyer sign-in helps keep order tracking connected to account and orders flow.": "La connexion relie le suivi à votre compte et vos commandes.",
  "Continue to tracking for order {order}.": "Continuez vers le suivi de la commande {order}.",
  "Orders": "Commandes",
  "Back to orders": "Retour aux commandes",
  "Return to the buyer orders area.": "Revenir à vos commandes.",
  "Open your buyer account foundation.": "Ouvrir votre compte acheteur.",
  "Track your order": "Suivre votre commande",
  "This storefront page is ready for real shipment tracking, order status updates, and delivery milestones.": "Suivez ici l'état de votre commande et de sa livraison.",
  "Tracking reference": "Référence de suivi",
  "Order number unavailable": "Numéro de commande indisponible",
  "This is a storefront tracking foundation. Once the real order and shipment APIs are connected, the page can show live shipment status, courier updates, and estimated delivery.": "Le suivi en temps réel (transporteur, date estimée) arrivera bientôt sur cette page.",
  "Order progress": "Avancement",
  "Completed": "Terminé",
  "Pending": "En attente",
  "Tracking notes": "Notes de suivi",
  "Tracking becomes much more useful once real order submission and shipment APIs are connected.": "Le suivi détaillé arrivera avec l'intégration des transporteurs.",
  "Buyer sign-in keeps tracking linked to account and order history.": "La connexion relie le suivi à votre historique.",
  "Order number is already wired into the route structure for future backend integration.": "Le numéro de commande est déjà pris en compte.",
  "Route readiness": "État de la page",
  "Route param": "Paramètre",
  "Tracking state": "État du suivi",
  "Foundation ready": "Prêt",
  "What comes next": "Prochaines étapes",
  "Real order lookup by order number.": "Recherche de commande par numéro.",
  "Shipment carrier and tracking code integration.": "Transporteur et code de suivi.",
  "Buyer notifications and delivery milestone updates.": "Notifications de livraison.",
  "Describe the part": "Décrivez la pièce",
  "Your vehicle and the part you need. It's free.": "Votre véhicule et la pièce recherchée. C'est gratuit.",
  "Sellers reply": "Les vendeurs répondent",
  "Matching shops and casses send you their best offer.": "Les magasins et casses concernés vous envoient leur meilleure offre.",
  "Pick the best offer": "Choisissez la meilleure offre",
  "Compare price, condition and warranty, then contact the seller.": "Comparez prix, état et garantie, puis contactez le vendeur.",
  "Could not send your request": "Impossible d'envoyer votre demande",
  "Can't find your part? Let the sellers come to you.": "Pièce introuvable ? Laissez les vendeurs venir à vous.",
  "Send one request and every matching shop and dismantler on PartHub can reply with an offer.": "Envoyez une seule demande : tous les magasins et casses concernés sur PartHub peuvent vous répondre.",
  "Sign in to send a request": "Connectez-vous pour envoyer une demande",
  "We need an account so sellers' offers reach you and only you can accept them.": "Un compte est nécessaire pour recevoir les offres et être seul à pouvoir les accepter.",
  "Sign in or create an account": "Se connecter ou créer un compte",
  "🚗 Your vehicle": "🚗 Votre véhicule",
  "e.g. Renault": "ex. Renault",
  "e.g. Clio": "ex. Clio",
  "e.g. 2015": "ex. 2015",
  "e.g. 1.5 dCi": "ex. 1.5 dCi",
  "VIN (chassis number)": "VIN (numéro de châssis)",
  "Optional, but helps sellers find the exact part. 17 characters.": "Facultatif, mais aide à trouver la pièce exacte. 17 caractères.",
  "⚙️ The part you need": "⚙️ La pièce recherchée",
  "Part": "Pièce",
  "e.g. Alternator, front left headlight…": "ex. Alternateur, phare avant gauche…",
  "Not sure": "Je ne sais pas",
  "OEM / part number": "Référence OEM / pièce",
  "If you know it": "Si vous la connaissez",
  "Details": "Détails",
  "Side, colour, what's wrong, anything that helps…": "Côté, couleur, panne, tout ce qui aide…",
  "📍 Contact": "📍 Contact",
  "e.g. Casablanca": "ex. Casablanca",
  "Phone / WhatsApp": "Téléphone / WhatsApp",
  "We'll message you on WhatsApp when offers arrive. Only shared with the seller whose offer you accept.": "Nous vous prévenons sur WhatsApp à chaque offre. Votre numéro n'est partagé qu'avec le vendeur dont vous acceptez l'offre.",
  "Sending…": "Envoi…",
  "Uploading photos…": "Envoi des photos…",
  "Send request to sellers": "Envoyer la demande aux vendeurs",
  "Free · Open for 14 days · No obligation to buy": "Gratuit · Ouverte 14 jours · Sans obligation d'achat",
  "View my requests →": "Voir mes demandes →",
  "Buyer account foundation": "Compte acheteur",
  "Sign in to access your account": "Connectez-vous pour accéder à votre compte",
  "View buyer information, orders, vehicle context, and continue the storefront flow.": "Consultez vos informations, commandes et véhicule.",
  "Unlock account and order continuity.": "Retrouvez votre compte et vos commandes.",
  "Current cart": "Panier actuel",
  "Go to cart": "Voir le panier",
  "Review your parts before checkout.": "Vérifiez vos pièces avant de commander.",
  "Catalog": "Catalogue",
  "Continue exploring inventory.": "Continuez à parcourir le catalogue.",
  "Your buyer account": "Votre compte acheteur",
  "Central place for buyer identity, order entry points, cart context, and selected vehicle.": "Vos informations, commandes, panier et véhicule au même endroit.",
  "View orders": "Voir les commandes",
  "Sign out": "Se déconnecter",
  "Buyer profile": "Profil acheteur",
  "Not available": "Non disponible",
  "Role": "Rôle",
  "Session state": "Session",
  "Authenticated storefront buyer session active": "Connecté en tant qu'acheteur",
  "Update vehicle": "Modifier le véhicule",
  "No vehicle selected yet.": "Aucun véhicule choisi.",
  "Storefront state": "État",
  "Orders area": "Commandes",
  "Ready": "Prêt",
  "Orders history can plug into real buyer order APIs later.": "L'historique détaillé des commandes arrive bientôt.",
  "Account profile details can expand without touching seller/admin portals.": "D'autres informations de profil arriveront bientôt.",
  "Vehicle context remains reusable across browsing and checkout.": "Votre véhicule est utilisé pour la recherche et la commande.",
  "You can add up to {n} photos.": "Vous pouvez ajouter jusqu'à {n} photos.",
  "Upload failed": "Échec de l'envoi",
  "Photos": "Photos",
  "Uploading…": "Envoi…",
  "Remove photo": "Retirer la photo",
  "Add photo": "Ajouter une photo",
  "Optional · up to 3 photos of the old part, its label or where it fits.": "Facultatif · jusqu'à 3 photos de l'ancienne pièce, de son étiquette ou de son emplacement.",
  "Buyer": "Acheteur",
  "1 offer": "1 offre",
  "{n} offers": "{n} offres",
};
